import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const BenefitsPanel = () => {
  const benefits = [
  {
    icon: 'Sparkles',
    title: 'Recommandations IA Personnalisées',
    description: 'Notre intelligence artificielle analyse votre profil pour vous suggérer les meilleures filières adaptées à vos talents et aspirations.'
  },
  {
    icon: 'Trophy',
    title: 'Système de Gamification',
    description: 'Gagnez des points et des badges en explorant différentes filières et en complétant des quiz interactifs.'
  },
  {
    icon: 'Target',
    title: 'Orientation Précise',
    description: 'Découvrez des informations détaillées sur chaque filière, les débouchés professionnels et les écoles au Sénégal.'
  },
  {
    icon: 'Users',
    title: 'Accompagnement Complet',
    description: 'Accès pour vos parents et conseillers pour un suivi personnalisé de votre parcours d\'orientation.'
  }];


  const testimonials = [
  {
    name: 'Fatou Sall',
    level: 'Terminale S',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ad91979a-1763295629510.png",
    imageAlt: 'Smiling young African woman with braided hair wearing white shirt in bright classroom setting',
    quote: 'Grâce à CURSUS, j\'ai découvert ma passion pour l\'ingénierie informatique. Les recommandations étaient parfaites !'
  },
  {
    name: 'Moussa Diop',
    level: 'Première L',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_127400d6a-1763296439452.png",
    imageAlt: 'Confident young African man with short hair wearing blue polo shirt smiling at camera in school environment',
    quote: 'Le système de quiz m\'a aidé à mieux comprendre mes points forts. Maintenant je sais quelle voie suivre.'
  }];


  return (
    <div className="space-y-6 md:space-y-8 lg:space-y-10">
      <div className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl p-6 md:p-8 lg:p-10 text-white">
        <div className="flex items-center gap-3 mb-4 md:mb-5 lg:mb-6">
          <div className="w-10 h-10 md:w-12 md:h-12 lg:w-14 lg:h-14 bg-white/20 rounded-full flex items-center justify-center">
            <Icon name="Rocket" size={24} className="md:w-7 md:h-7 lg:w-8 lg:h-8" />
          </div>
          <h2 className="text-xl md:text-2xl lg:text-3xl font-bold">
            Bienvenue sur CURSUS Orientation
          </h2>
        </div>
        <p className="text-sm md:text-base lg:text-lg text-white/90 leading-relaxed">
          Rejoignez des milliers d'étudiants sénégalais qui ont trouvé leur voie grâce à notre plateforme d'orientation intelligente. Votre avenir commence ici !
        </p>
      </div>
      <div>
        <h3 className="text-lg md:text-xl lg:text-2xl font-semibold text-gray-900 mb-4 md:mb-5 lg:mb-6">
          Pourquoi Choisir CURSUS ?
        </h3>
        <div className="space-y-4 md:space-y-5">
          {benefits?.map((benefit, index) =>
          <div
            key={index}
            className="bg-white rounded-lg p-4 md:p-5 lg:p-6 border border-gray-200 hover:border-blue-300 hover:shadow-md transition-all duration-300">

              <div className="flex items-start gap-3 md:gap-4">
                <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 lg:w-14 lg:h-14 bg-blue-50 rounded-lg flex items-center justify-center">
                  <Icon name={benefit?.icon} size={20} className="md:w-6 md:h-6 lg:w-7 lg:h-7 text-blue-600" />
                </div>
                <div>
                  <h4 className="text-base md:text-lg font-semibold text-gray-900 mb-1 md:mb-2">
                    {benefit?.title}
                  </h4>
                  <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                    {benefit?.description}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="bg-gray-50 rounded-xl p-6 md:p-8 lg:p-10">
        <h3 className="text-lg md:text-xl lg:text-2xl font-semibold text-gray-900 mb-4 md:mb-6 lg:mb-8">
          Ce Que Disent Nos Étudiants
        </h3>
        <div className="space-y-4 md:space-y-5 lg:space-y-6">
          {testimonials?.map((testimonial, index) =>
          <div
            key={index}
            className="bg-white rounded-lg p-4 md:p-5 lg:p-6 border border-gray-200">

              <div className="flex items-start gap-3 md:gap-4 mb-3 md:mb-4">
                <Image
                src={testimonial?.image}
                alt={testimonial?.imageAlt}
                className="w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 rounded-full object-cover" />

                <div>
                  <h4 className="text-base md:text-lg font-semibold text-gray-900">
                    {testimonial?.name}
                  </h4>
                  <p className="text-xs md:text-sm text-gray-500">
                    {testimonial?.level}
                  </p>
                </div>
              </div>
              <p className="text-sm md:text-base text-gray-700 italic leading-relaxed">
                "{testimonial?.quote}"
              </p>
            </div>
          )}
        </div>
      </div>
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 md:p-5 lg:p-6">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} className="md:w-6 md:h-6 text-blue-600 flex-shrink-0 mt-1" />
          <div>
            <h4 className="text-sm md:text-base font-semibold text-gray-900 mb-1 md:mb-2">
              Vos Données Sont Sécurisées
            </h4>
            <p className="text-xs md:text-sm text-gray-600 leading-relaxed">
              Nous respectons votre vie privée. Toutes vos informations sont cryptées et ne seront jamais partagées sans votre consentement.
            </p>
          </div>
        </div>
      </div>
    </div>);

};

export default BenefitsPanel;